import { Box, Circle, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import { FaFileSignature, FaUser } from 'react-icons/fa'
import { MdThumbsUpDown } from 'react-icons/md'
import { Outlet, useLocation } from 'react-router-dom'

export const LinhaDoTempo: React.FC = () => {
  const location = useLocation()
  const linhaDoTempo2 = location.pathname.includes('VisualizacaoSolicitacao')
  const linhaDoTempo3 = location.pathname.includes('AssinaturaConfirmacao')

  return (
        <Flex flexDirection={'column'} minHeight={'calc(100vh - 56px)'}>
            <Flex
            padding="2.5rem"
            flexDirection="column"
            gap="1.5rem"
            width="full"
            mb={'4rem'}
            >
            <Heading as="h1" color="#1961E0">Assinatura de documento de cargo</Heading>

            <Box position="relative" mt="3rem" width="100%">

                {/* Linha */}
                <Box
                position="absolute"
                top="25px"
                left="32%"
                right="32%"
                height="2px"
                bg="#9faabf"
                zIndex={0}
                />

                {/* Etapas */}
                <Flex justifyContent="space-between" px="20%" zIndex={1} position="relative" mr={'10%'} ml={'10%'}>

                    <VStack spacing="6px">
                        <Circle size="50px" bg="#1961E0" color="white">
                            <FaUser size={25} />
                        </Circle>
                        <Text fontSize="sm" fontWeight="bold">Identificação</Text>
                    </VStack>

                    <VStack spacing="6px">
                        <Circle size="50px" bg={linhaDoTempo2 || linhaDoTempo3 ? '#1961E0' : 'gray.300'} color="white">
                            <MdThumbsUpDown size={25} />
                        </Circle>
                        <Text fontSize="sm" fontWeight="bold">Visualização e solicitação de correções</Text>
                    </VStack>

                    <VStack spacing="6px">
                        <Circle size="50px" bg={linhaDoTempo3 ? '#1961E0' : 'gray.300'} color="white">
                            <FaFileSignature size={25} />
                        </Circle>
                        <Text fontSize="sm" fontWeight="bold">Assinatura</Text>
                    </VStack>

                </Flex>
            </Box>
            </Flex>

            <Outlet/>
        </Flex>
  )
}
